import { DeviceType } from "../models/constants/deviceType";

class DeviceService {
    private getWidth(): number {
        return window.innerWidth;
    }

    isMobile(): boolean {
        return this.getWidth() < 768;
    }

    isTablet(): boolean {
        const width = this.getWidth();
        return width >= 768 && width < 1024;
    }

    isDesktop(): boolean {
        return this.getWidth() >= 1024;
    }

    getDeviceType() {
        if (this.isMobile()) return DeviceType.Mobile;
        if (this.isTablet()) return DeviceType.Tablet;
        return DeviceType.Web;
    }
}

export const deviceService = new DeviceService();
